import { Controller } from "@hotwired/stimulus"

// Auto-submit form when field changes
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
